'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _uniqueId = require('lodash/uniqueId');

var _uniqueId2 = _interopRequireDefault(_uniqueId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RenderSummaryResults = function (_Component) {
  _inherits(RenderSummaryResults, _Component);

  function RenderSummaryResults(props) {
    _classCallCheck(this, RenderSummaryResults);

    var _this = _possibleConstructorReturn(this, (RenderSummaryResults.__proto__ || Object.getPrototypeOf(RenderSummaryResults)).call(this, props));

    _this.uuid = (0, _uniqueId2.default)();
    return _this;
  }

  _createClass(RenderSummaryResults, [{
    key: 'isCorrect',
    value: function isCorrect(answer) {
      return answer.selected.toLowerCase() === 'correct';
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var data = this.props.data;


      return _react2.default.createElement(
        'div',
        { className: 'quizResultsTable' },
        data.map(function (result, i) {
          return _react2.default.createElement(
            'div',
            {
              key: 'quizResultsTable_' + _this2.uuid + '_' + i,
              className: 'quizResultsTable__row'
            },
            _react2.default.createElement(
              'div',
              { className: 'quizResultsTable__questionText' },
              result.questionText
            ),
            _react2.default.createElement(
              'div',
              { className: 'quizResultsTable__givenAnswers' },
              result.givenAnswers.map(function (answer, j) {
                return _react2.default.createElement(
                  'span',
                  { key: 'quizResultsTable_' + _this2.uuid + '_givenAnswers_' + i + '_' + j, style: { color: !_this2.isCorrect(answer) && 'red' } },
                  _this2.isCorrect(answer) ? '✔︎ ' : '✘ ',
                  answer.text
                );
              })
            ),
            !result.correct && _react2.default.createElement(
              'div',
              { className: 'quizResultsTable__correctAnswers' },
              result.correctAnswers.map(function (answer, j) {
                return _react2.default.createElement(
                  'span',
                  { key: 'quizResultsTable_' + _this2.uuid + '_correctAnswers_' + i + '_' + j, style: { color: 'green' } },
                  answer.text
                );
              })
            ),
            result.isExample && _react2.default.createElement(
              'div',
              { className: 'quizResultsTable__exampleAnswers' },
              'Answer appears here'
            )
          );
        })
      );
    }
  }]);

  return RenderSummaryResults;
}(_react.Component);

exports.default = RenderSummaryResults;


//////////////////
// WEBPACK FOOTER
// ./node_modules/wse-quiz-component/lib/RenderSummaryResults.js
// module id = 369
// module chunks = 0